var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isButtonVisible)?_c('base-material-design-icon',{attrs:{"icon":"camera"},on:{"click":_vm.takePhoto}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }